<mat-form-field
  appearance="outline"
  [subscriptSizing]="showBottomMargin ? 'fixed' : 'dynamic'"
  floatLabel="always"
  [class]="
    (selectBoxOptions.dbKey && isAdmin) || selectBoxOptions.gridId
      ? 'sia-input sia-small-width ' + inputClass
      : 'sia-input sia-inputs-full ' + inputClass
  "
  outsideClick
  [outsideClickActive]="isOpen"
  (clickedOutside)="closeSelectOptions()"
>
  <mat-select
    multiple
    [siaTooltip]="getFieldErrors()"
    [disable]="!isVisibleTooltip()"
    [(ngModel)]="value"
    [sortComparator]="selectedOrderComparator"
    [disabled]="disabled"
    [id]="id ?? ''"
    [tabIndex]="tabDisabled ? '-1' : '0'"
    (openedChange)="openChange($event)"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur($event)"
    #selectInput
    [placeholder]="selectBoxOptions.emptyElementLabel ?? ''"
  >
    @if (showVisibilityButton) {
      <button
        mat-icon-button
        [siaTooltip]="showAll ? 'Nascondi disabitati' : 'Mostra tutti i valori'"
        tabindex="-1"
        (click)="toggleVisibility()"
        class="sia-select-box-view"
      >
        <mat-icon>
          {{ showAll ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </button>
    }
    @for (field of hiddenSelectedOptions; track field?.id) {
      <mat-option [value]="field.id" style="height: 0px; display: none">
        @if (selectBoxOptions.translateData) {
          {{ field.description | siaTranslate }}
        } @else {
          {{ field.description }}
        }
      </mat-option>
    }

    <mat-option>
      <ngx-mat-select-search
        [disableInitialFocus]="!!isMobile"
        [placeholderLabel]="'Cerca' | siaTranslate"
        [noEntriesFoundLabel]="'Nessun elemento trovato' | siaTranslate"
        [formControl]="selectFilterCtrl"
        ngDefaultControl
        (focusin)="onSearchFocus()"
        (click)="onSearchFocus()"
      ></ngx-mat-select-search>
    </mat-option>

    <cdk-virtual-scroll-viewport
      class="virtual-scroll overflow-x-hidden"
      [style.height.px]="viewportHeight"
      [itemSize]="viewportItemSize"
      [maxBufferPx]="viewportItemSize * 10"
      [minBufferPx]="viewportItemSize * 10"
    >
      <mat-option
        *cdkVirtualFor="let field of filteredDataSource; trackBy: trackById"
        [value]="field.id"
        class="sia-select-option"
        [class]="field?.disabled ? 'sia-select-option--disabled' : ''"
      >
        @if (selectBoxOptions.translateData) {
          {{ field.description | siaTranslate }}
        } @else {
          {{ field.description }}
        }
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-select>

  <mat-label
    >{{ label | siaTranslate }}
    @if (info) {
      <span
        [siaTooltip]="info"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon"
      >
      </span>
    }
  </mat-label>

  @if (showBottomMargin) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage"
      [statusMessages]="statusMessages"
    ></mat-hint>
  }
</mat-form-field>
<!-- PULSANTE DB EDIT -->

@if (selectBoxOptions.dbKey && isAdmin && !selectBoxOptions.gridId) {
  <div class="admin-tools">
    <div class="admin-tools-sql-view">
      <button
        mat-icon-button
        [siaTooltip]="selectBoxOptions.dbKey"
        tabindex="-1"
        (click)="updateSqlView()"
      >
        <span
          class="material-symbols-outlined admin-tools-sql-view__icon"
          title="Modifica Vista"
        >
          table
        </span>
      </button>
    </div>
  </div>
} @else if (selectBoxOptions.gridId) {
  <div class="admin-tools">
    <div class="admin-tools-sql-view">
      <button
        mat-icon-button
        [siaTooltip]="'Visualizza griglia'"
        [disabled]="disabled"
        tabindex="-1"
        (click)="showRadar()"
      >
        <span
          class="material-symbols-outlined admin-tools-sql-view__icon"
          title="Visualizza griglia"
        >
          table
        </span>
      </button>
    </div>
  </div>
}
